itsoftApp.createModule("scrollEffects", ["windowScroll"], function() {
    var module = this;

    function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
        this._self = self;
        this._classAnimate = classAnimate;
        this._obj = obj,
        this._callBack = callBack;
        this._scrollPoint;
        this._oldClass = oldClass;
        this.init();
    }

    ScrollEffects.prototype.init = function() {
        var self = this;

        function show (scroll, number) {
            var scrolled = pageYOffset;
            var coeff;

            if (number) {
                coeff = number;
            } else {
                coeff = 1.3;
            }

            self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);
            // console.log(scrolled + window.innerHeight / coeff, ">=", self._scrollPoint + scrolled, self);
            if (scrolled + window.innerHeight / coeff >= (self._scrollPoint + scrolled)) {
                self.fadeIn();
            }
        }

        show("auto", 1);

        itsoftApp.modules.windowScroll.addEvent(show);
    }

    ScrollEffects.prototype.fadeIn = function() {
        if (typeof this._callBack === "function") {
            this._callBack.call(this._obj);
        } else {
            if (this._oldClass) {
                this._self.classList.remove(this._oldClass);

                if (this._self.classList.contains("js-slider")) {
                    itsoftApp.modules.slidersLibrary.callback(this._self);
                }

                if (this._self.classList.contains("js-accordion")) {
                    itsoftApp.modules.accordion.callback(this._self);
                }

                if (this._self.classList.contains("js-tabs-section")) {
                    itsoftApp.modules.toggleTabs.callback(this._self);
                }

                if (this._self.classList.contains("js-circle-section")) {
                    itsoftApp.modules.createCircle.callback();
                }

                if (this._self.classList.contains("js-filter")) {
                    var ranges = this._self.querySelectorAll(".js-range");
                    var filterElement = this._self;
                    var form = this._self.querySelector(".js-filter-form");

                    if (ranges.length > 0) {
                        Array.prototype.forEach.call(ranges, function (range, index, rangesArr) {
                            if (index === rangesArr.length - 1) {
                                itsoftApp.modules.sliderRange.callback(range, form);
                            } else {
                                itsoftApp.modules.sliderRange.callback(range);
                            }
                        });
                    } else {
                        itsoftApp.modules.filters.callback(form);
                    }
                }

                if (this._self.classList.contains("js-validation")) {
                    itsoftApp.modules.formsValidation.callback(this._self);
                }

                if (this._self.classList.contains("js-map-section")) {
                    itsoftApp.modules.insertMap.callback(this._self);
                }

                if (this._self.classList.contains("js-video-block")) {
                    itsoftApp.modules.video.callback(this._self);
                }

                if (this._self.hasAttribute("data-popup-source")) {
                    itsoftApp.modules.popups.callback.createImagePopup(this._self);
                }

                // if (this._self.classList.contains("js-select")) {
                //     itsoftApp.modules.select.callback(this._self);
                // }

                this._oldClass = undefined;
            }
            this._self.classList.add(this._classAnimate);
        }
    }


    module.ScrollEffects = ScrollEffects;

});
